(function () {
    'use strict';

    angular
        .module('edufindme')
        .config(EdufindmeRoute);

    EdufindmeRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function EdufindmeRoute ($stateProvider) {
        $stateProvider
            .state('root.edufindme', {
                abstract: true,
                url: '/edufindme',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.edufindme.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/edufindme/findClients/list/list.html',
                        controller: 'FindClientsListController',
                        controllerAs: 'edufindme',
                        resolve: {
                            clients: ['FindClientsService', function(FindClientsService) {
                                
                                return FindClientsService.getAll();
                            }]
                        },
                        onExit: function(){
                            // Remove the DataTables FixedHeader plugin's headers and footers
                            var fixedHeaderEle = document.getElementsByClassName('fixedHeader');
                            angular.element(fixedHeaderEle).remove();
                            var fixedFooterEle = document.getElementsByClassName('fixedFooter');
                            angular.element(fixedFooterEle).remove();
                        }
                    }
                }
            })
            .state ('root.edufindme.clientStatistics', {
                url: '/reports/clientStatistics',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/edufindme/report/clientStatistics.html',
                        controller: 'ReportsController',
                        controllerAs: 'reports'
                    }
                }
            })
            .state ('root.edufindme.accountDeleteRequest', {
                url: '/reports/account-delete-request',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/edufindme/account-delete-request/report.html',
                        controller: 'AccountDeleteRequestController',
                        controllerAs: 'accountDeleteRequest'
                    }
                }
            })
            .state ('root.edufindme.createAccount', {
                url: '/create-account/:type',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/edufindme/create-account/form.html',
                        controller: 'AccountCreateController',
                        controllerAs: 'accountCreate'
                    }
                },
                resolve: {
                    countries: function(CountriesNewService) {
                        return CountriesNewService.getCountries().then(function(response){
                            return response.data;
                        });
                    },
                    timezones: function(TimezonesService) {
                        return TimezonesService.getTimezones().then(function(response){
                            return response.data;
                        });
                    }
                }
            });
            // .state ('root.edufindme.expo', {
            //     url: '/expo/{id}',
            //     views: {
            //         'inner-expo@root': {
            //             templateUrl: 'templates/edufindme/findClients/list/expo.html',
            //             controller: 'FindClientsExpoController',
            //             controllerAs: 'expo'
            //
            //         }
            //     }
            // })

    }
})();